import React from "react";
import "./deleteDialog.scss";
import { useTranslation } from "react-i18next";

export default function DeleteDialog({
    data = { title: "", name: "", id: "" },
    onDeleteClick,
    onClose,
}) {
    const { t } = useTranslation();

    return (
        <div className="confirm__wrapper">
            <ul className="confirm__list">
                <li className="confirm__item">
                    <h2 className="confirm__title title--yellow">{data.title}</h2>
                </li>
                <li className="confirm__item">
                    <p className="confirm__option">
                        {t("delete.deleteMessage")} {data.type}{data.name ? <> <b>{data.name}</b></> : ""}?
                    </p>
                </li>
                <li className="confirm__item">
                    <button
                        className="popup__button"
                        type="button"
                        onClick={() => onDeleteClick(data.id, onClose)}
                    >
                        {t("delete.delete")}
                    </button>
                    <button
                        className="popup__button popup__button--cancel"
                        type="button"
                        onClick={onClose}
                    >
                        {t("delete.cancel")}
                    </button>
                </li>
            </ul>
            <button
                className="popup__close-button payment-confirm__close-button"
                type="button"
                onClick={onClose}
            />
        </div>
    );
}
